var enums = {
  tradeType: {
    TENDER: "Tender",
    BILATERAL: "Bilateral",
    AUCTION: "Auction",
    DEAL_CONFIRMATION: "Deal Confirmation"
  },
  transactionType: {
    REQUEST_TO_PURCHASE: "Purchase",
    OFFER_TO_SELL: "Sale"
  },
  tradeValidityType: {
    NONE: "No default validity",
    DEFAULT: "Default validity",
    FIXED: "Fixed validity"
  },
  tradeStatus: {
    DRAFT: "Draft",
    LIVE: "Live",
    CONSIDERATION: "Consideration",
    CLOSED: "Closed"
  },
  documentType: {
    CONTRACT: "Contract",
    CREDIT: "Credit",
    INVOICE: "Invoice",
    SHIPPING: "Shipping",
    OTHER: "Other"
  },
  activityLogType: {
    USER_LOGIN: "User Login",
    USER_AUTHENTICATED: "User Authenticated",
    PASSWORD_RESET_REQUESTED: "Password Reset Requested",
    PASSWORD_CHANGED: "Password Changed",
    USER_CREATED: "User Created",
    USER_ACTIVATED: "User Activated",
    USER_DEACTIVATED: "User Deactivated",
    USER_UPDATED: "User Updated",
    USER_DELETED: "User Deleted",
    USER_CHAT_ALIAS_UPDATED: "Chat Alias Updated",
    COMPANY_CREATED: "Company Created",
    COMPANY_UPDATED: "Company Updated",
    COMPANY_DEACTIVATED: "Company Deactivated",
    COMPANY_ACTIVATED: "Company Activated",
    COMPANY_DELETED: "Company Deleted",
    TEMPLATE_CREATED: "Template Created",
    TEMPLATE_UPDATED: "Template Updated",
    TEMPLATE_DELETED: "Template Deleted",
    TEMPLATE_PUBLISHED: "Template Published",
    TRADE_INITIATED: "Trade Initiated",
    TRADE_VIEWED: "Trade Viewed",
    TRADE_DELETED: "Trade Deleted",
    DRAFT_TRADE_CREATED: "Draft Trade Created",
    DRAFT_TRADE_UPDATED: "Draft Trade Updated",
    DRAFT_TRADE_DELETED: "Draft Trade Deleted",
    TRADE_APPROVED: "Trade Approved",
    TRADE_END_TIME_CHANGED: "Trade End Time Changed",
    TRADE_CLOSED: "Trade Closed",
    COUNTERPARTY_ADDED_TO_TRADE: "Counterparty Added To Trade",
    DOCUMENT_ADDED_TO_TRADE: "Document Added To Trade",
    DOCUMENT_EDITED: "Document Edited",
    DOCUMENT_DELETED: "Document Deleted",
    BASE_TERMS_UPDATED: "Base Terms Updated",
    WORKING_DRAFT_CREATED: "Working Draft Created",
    WORKING_DRAFT_UPDATED: "Working Draft Updated",
    WORKING_DRAFT_DELETED: "Working Draft Deleted",
    DRAFT_TERM_SHEET_SENT: "Draft Term Sheet Sent",
    DRAFT_TERM_SHEET_RECEIVED: "Draft Term Sheet Received",
    BID_SENT: "Bid Sent",
    OFFER_SENT: "Offer Sent",
    BID_RECEIVED: "Bid Received",
    OFFER_RECEIVED: "Offer Received",
    BID_WITHDRAWN: "Bid Withdrawn",
    OFFER_WITHDRAWN: "Offer Withdrawn",
    BID_EXPIRED: "Bid Expired",
    OFFER_EXPIRED: "Offer Expired",
    BID_AWARDED: "Bid Awarded",
    OFFER_AWARDED: "Offer Awarded",
    BID_DECLINED: "Bid Declined",
    OFFER_DECLINED: "Offer Declined",
    BID_REJECTED: "Bid Rejected",
    OFFER_REJECTED: "Offer Rejected",
    MESSAGE_SENT: "Message Sent",
    MESSAGE_RECEIVED: "Message Received",
    TRADE_NOTE_ADDED: "Trade Note Added",
    TRADE_NOTE_EDITED: "Trade Note Edited",
    TRADE_CONSIDERATION_END_TIME_CHANGED: "Trade Consideration End Time Changed",
    ROLE_UPDATED: "Role Updated",
    ROLE_CREATED: "Role Created",
    USER_ROLE_ADDED: "User Role Added",
    USER_ROLE_REMOVED: "User Role Removed",
    USER_PERMISSION_UPDATED: "User Permission Updated",
    TERMSHEETREVIEW_COMMENTED: "Review Commented",
    TERMSHEETREVIEW_DECLINED: "Review Declined",
    TERMSHEETREVIEW_REQUESTED: "Review Requested",
    TERMSHEETREVIEW_REVERTED: "Review Reverted",
    TERMSHEETREVIEW_SUPPORTED: "Review Supported",
    TERMSHEET_EXPORTED: "Term Sheet Exported",
    TRADE_GENERAL_INFO_UPDATED: "Trade General Info Updated",
    MESSAGE_ALL: "Message All",
    DEAL_CONFIRMED: "Deal Confirmed"
  },
  termsheetReviewStatus: {
    PENDING: "Pending",
    DECLINED: "Declined",
    SUPPORTED: "Supported"
  }
};

var en = {
  translation: {
    ...enums,
    components: {
      // TODO: Does this belong here?
      chat: {
        notes: {
          inputPlaceholder: "Type your notes here...",
          confirmLabel: "Add"
        },
        chat: {
          inputPlaceholder: "Type your message here...",
          confirmLabel: "Send"
        },
        attachLabel: "Upload",
        messageDisclaimer: "Messages sent using the messaging tool are informal, and do not form part of the Term Sheet, or any bid or offer."
      }
    }
  }
};

const resources = {
  en
};

export { resources };
//# sourceMappingURL=index.esm.js.map
